!function(window) {

$('#entrySlick').slick({
	slidesToShow: 1,
	slidesToScroll: 1,
	autoplay: true,
	autoplaySpeed: 2000,
	infinite: true,
	draggable: true,
	dots: true,
	arrows: false,
	fade: true,
	cssEase: 'linear'
});

$('#exposedNews').slick({
	slidesToShow: 1,
	slidesToScroll: 1,
	autoplay: true,
	autoplaySpeed: 2000,
	infinite: true,
	draggable: true,
	dots: true,
	arrows: false,
	fade: true,
	cssEase: 'linear',
	adaptiveHeight: false
});

$(window).load(function () {
	
	$('.slick-content').slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		initialSlide:0,
		centerMode: true,
		autoplay: true,
		autoplaySpeed: 3000,
		infinite: false,
		variableWidth: true,
		draggable: true,
		dots: false,
		arrows: true,
		prevArrow: $('.slick-arrow.prev'),
		nextArrow: $('.slick-arrow.next'),
		accessibility: true,
	});
	
});

function triggerLightGallery(){
	let selector = $('.lightgallery');
	
	if(selector.length){
		$(selector).lightGallery({
			download: false,
			thumbnail:true,
			exThumbImage: 'data-src'
		});
		$('.open-gal').on('click', function(){
			$('.lightgallery a:first-child').trigger("click");
		});
	}
}
triggerLightGallery();

$('#mapEntry .area').on('click', function(e){
	
	$("#mapEntry .area").removeClass('active');
	$(e.target).addClass('active');
	
	// jump to slide
	var areaId = $(e.target).attr('id');
	console.log(areaId);
	const slide = $("#entrySlick").find(`[data-slide-name="${areaId}"]`);
	const slideNo = slide.data('slick-index');
	$('#entrySlick').slick('slickGoTo', slideNo);
});

$('#entrySlick').on('beforeChange', function(event, slick, currentSlide, nextSlide){
	const slideName = $("#entrySlick").find(`[data-slick-index="${nextSlide}"]`).data('slide-name');
	$("#mapEntry .area").removeClass('active');
	$(`#mapEntry .area#${slideName}`).addClass('active');
});


window.triggerLightGallery = triggerLightGallery;
}(window);